import React from "react";
import { Button } from "@mui/material";

import {
  DeeperInsightsSectionContainer,
  DeeperInsightsImageWrapper,
  DeeperInsightsHeading,
  DeeperInsightsDescription,
  DeeperInsightsButtonWrapper,
  DeeperInsightsDesktopImage,
  DeeperInsightsMobileImage,
} from "../../assets/styles/HomeStyles"; 

import DesktopOnePlatformImg from "../../assets/icons/desktop_one_platform_img.png";
import MobileOnePlatformImg from "../../assets/icons/mobile_one_platform_img.png";
import { useNavigate } from "react-router-dom";

const DeeperInsights = () => {
  const navigate = useNavigate();

  return (
    <DeeperInsightsSectionContainer>
      <DeeperInsightsImageWrapper>
        <DeeperInsightsDesktopImage src={DesktopOnePlatformImg} alt="Desktop View" />
        <DeeperInsightsMobileImage src={MobileOnePlatformImg} alt="Mobile View" />
      </DeeperInsightsImageWrapper>
      <DeeperInsightsHeading>One Platform, Deeper Insights</DeeperInsightsHeading>
      <DeeperInsightsDescription>
        Welcome to Devia where we revolutionize risk management and information
        sharing across your organization. Our platform seamlessly gathers and
        analyzes data from third parties delivering clear insights into
        strengths and vulnerabilities.
      </DeeperInsightsDescription>
      <DeeperInsightsDescription>
        With just a click of a button, you can customize risk parameters
        tailored to your unique business needs, putting control directly in your
        hands. Experience how our platform's flexibility and ease of use can
        elevate your strategic planning and operational efficiency.
      </DeeperInsightsDescription>
      <DeeperInsightsButtonWrapper>
        <Button className="custom-button" variant="contained"  onClick={() => navigate("/contact-us")} >
          Get Demo
        </Button>
      </DeeperInsightsButtonWrapper>
    </DeeperInsightsSectionContainer>
  );
};

export default DeeperInsights;
